import { render, staticRenderFns } from "./ModalAccess.vue?vue&type=template&id=5b529740&"
import script from "./ModalAccess.vue?vue&type=script&lang=js&"
export * from "./ModalAccess.vue?vue&type=script&lang=js&"
import style0 from "./ModalAccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports